import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SurveyResponse } from '../api/models';
// import { AuthService } from'../../public-api';
import { AuthService } from '../api/services';
// import { environment } from 'src/environment';
// import { LoginService } from '../api/services';
// import { ApiHelperService } from './api-helper.service';

// export interface ChangePasswordData {
//   userToken: string;
//   password: string;
// }

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  token: string;
  isAdmin: boolean;
  surveys?: null | Array<SurveyResponse>;
}

@Injectable({
  providedIn: 'root'
})
export class AccountService {


  public userSubject$: BehaviorSubject<User | null>;
  // public selectedSurveyId$: BehaviorSubject<number | null> = new BehaviorSubject(null);
  public selectedSurveyInstanceId$: BehaviorSubject<number | null> = new BehaviorSubject(null);
  // public user: Observable<User | null>;

  // private changePasswordData: ChangePasswordData;

  constructor(
      private router: Router,
      private loginService: AuthService,
      // private apiHelperService: ApiHelperService
  ) {
    const user = this.getUser();
    this.userSubject$ = new BehaviorSubject(user);
  }

  public get userValue() {
    return this.userSubject$.value;
  }

  public get selectedSurveyInstanceId() {
    return this.selectedSurveyInstanceId$.value;
  }

  // public get changeDataUserToken() {
  //   return this.changePasswordData ? this.changePasswordData.userToken : null;
  // }

  login(email: string, password: string) {
    return this.loginService.apiAuthPasswordauthenticateGet$Json({ email: email,
      password: password
    }).pipe(map(res => {
      const user = {
        id: res.id,
        firstName: res.firstName,
        lastName: res.lastName,
        email: email,
        token: res.token,
        isAdmin: res.isAdmin,
        surveys: res.surveys
      };
      // if (res.shouldChangePassword) {
      //   this.changePasswordData = {
      //     userToken: userToken,
      //     password: password
      //   }
      // }
      if (res.isAuthSuccessful /* && !res.shouldChangePassword */) {
        this.setUser(user);
        this.userSubject$.next(user);
      }
      return res;
    }));
  }

  logout() {
    this.router.navigate(['/login']).then(() => {
      this.removeUser();
      this.userSubject$.next(null);
    });
  }

  getUser() {
    const userJSON = localStorage.getItem('user');
    const user: User = userJSON ? JSON.parse(userJSON) : null;
    return user;
  }

  setUser(user: User) {
    localStorage.setItem("token", user.token);
    localStorage.setItem('user', JSON.stringify(user));
  }

  removeUser() {
    localStorage.removeItem("token");
    localStorage.removeItem('user');
  }

  setLanguage(language: string) {
    localStorage.setItem('language', language);
  }

  getLanguage() {
    var storageLanguage = localStorage.getItem('language');
    return storageLanguage ?? 'en';
  }

  markSurveyAsSubmitted(surveyId: number) {
    var user = this.getUser();
    var survey = user.surveys?.find(s => s.surveyId === surveyId);
    if (!survey) {
      return;
    }
    survey.isSurveyFinished = true;
    this.userSubject$.next(user);
    localStorage.setItem('user', JSON.stringify(user));
  }

  // setCurrentSurvey(surveyId: number) {
  //   this.selectedSurveyId$.next(surveyId);
  // }

  setCurrentSurveyInstance(surveyInstanceId: number) {
    this.selectedSurveyInstanceId$.next(surveyInstanceId);
  }
}
